import { render, staticRenderFns } from "./BaseAccessibleTable.vue?vue&type=template&id=ceec08fe&scoped=true&"
import script from "./BaseAccessibleTable.vue?vue&type=script&lang=js&"
export * from "./BaseAccessibleTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccessibleTable.vue?vue&type=style&index=0&id=ceec08fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceec08fe",
  null
  
)

export default component.exports